/* eslint-disable import/first */
import { createApp } from 'vue';
import router from '@/app/router';
import Maska from 'maska';
import store from '@/app/store/';
// import VueGoogleMaps from '@fawmi/vue-google-maps';

// console.log('process.env', process.env);
// import './serviceWorker/registerServiceWorker';
// import '@/registerServiceWorker';
import '@/app/styles/global.scss';
// eslint-disable-next-line import/order
import checkPwaOpened from '@/shared/lib/helpers/pwaOpenedWatcher';
import App from './App.vue';
// import { yaCounterByHostname } from '@/shared/lib/helpers/yandexCounter';

const app = createApp(App);
app.use(store)
	.use(router)
	.use(Maska)
	.mount('#app');

window.addEventListener('beforeinstallprompt', (event) => {
	console.log('beforeinstallprompt start', event);
	store.commit('SET_PWA_EVENT', event);
});

document.addEventListener('visibilitychange', () => {
	console.log('visibilitychange event:', document.visibilityState);
	if (document.visibilityState === 'visible') {
		checkPwaOpened('Инициализация страницы');
	}
});
function updateFavicon() {
	const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;

	const darkFavicon32 = '/img/favicon/favicon-dark-32x32.svg';
	const lightFavicon32 = '/img/favicon/favicon-light-32x32.svg';
	const faviconLink32 = document.querySelector('link[rel="icon"][sizes="32x32"]');
	faviconLink32.href = isDarkMode ? lightFavicon32 : darkFavicon32;

	const darkFavicon16 = '/img/favicon/favicon-dark-16x16.svg';
	const lightFavicon16 = '/img/favicon/favicon-light-16x16.svg';
	const faviconLink16 = document.querySelector('link[rel="icon"][sizes="16x16"]');
	faviconLink16.href = isDarkMode ? lightFavicon16 : darkFavicon16;
}

// Обновляем фавикон при загрузке страницы
updateFavicon();

// Добавляем слушатель для изменения темы
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
	updateFavicon();
});

// components.forEach((component) => app.component(component.name, component));
// directives.forEach((directive) => app.directive(directive.name, directive));

// .use(VueGoogleMaps, {
// 	load: {
// 		key: 'AIzaSyCo7t3VxPv_4vpf6Sq83c1x3_Qvw39cSMc',
// 	},
// })
